import { SbbLoadingIndicator } from "@sbb-esta/lyne-react/loading-indicator";
import React from "react";

export const InlineSpinner: React.FC = () => {
  return <SbbLoadingIndicator size="l" />;
};
